import { FC } from 'react';
import OptionsMenu from '../../../components/shared/OptionsMenu/OptionsMenu';
import ArrowIcon from '../../../components/svgs/arrowIcon';
import BtButton from '../../bt-button/bt-button';
import styles from './BidIntentControls.module.scss';
import {ReactComponent as CircleXIcon} from '../../../assets/svg/circleXIcon.svg';
import {ReactComponent as CircleCheckIcon} from '../../../assets/svg/circleCheckIcon.svg';
import { useTranslation } from 'react-i18next';

export enum BidIntentStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  UNDECIDED = 'UNDECIDED'
}

type props = {
  status: BidIntentStatus,
  onChange: (value: BidIntentStatus) => void
}

export const bidIntentOptions = {
  [BidIntentStatus.ACCEPTED]: {
    color: 'var(--green-700)',
    className: 'success',
    icon(color?: string, className?: string, ref?: any) {
      return <CircleCheckIcon className={className} ref={ref} fill={color || this.color} width='18px' height='18px' />
    }
  },
  [BidIntentStatus.DECLINED]: {
    color: 'var(--red-700)',
    className: 'failure',
    icon(color?: string, className?: string, ref?: any) {
      return <CircleXIcon className={className} ref={ref} fill={color || this.color} width='18px' height='18px' />
    }
  },
  [BidIntentStatus.UNDECIDED]: {
    color: 'var(--gray-700)',
    className: 'neutral',
    icon() {
      return null;
    }
  },
}

const BidIntentControls: FC<props> = ({ status = BidIntentStatus.UNDECIDED, onChange }) => {
  const [t] = useTranslation('quotation', { keyPrefix: 'bidIntent' });

  const bidIntentText = {
    [BidIntentStatus.ACCEPTED]: t('accept', 'Avser att lämna anbud'),
    [BidIntentStatus.DECLINED]: t('decline', 'Tacka nej'),
    [BidIntentStatus.UNDECIDED]: t('undecided', 'Ta bort avsiktsförklaring')
  };

  return (
    <div className={styles.container}>
      {status === BidIntentStatus.UNDECIDED ? (
        Object.entries(bidIntentOptions).filter(([key,]) => key !== BidIntentStatus.UNDECIDED).map(([key, value]) => (
          <BtButton
            key={key}
            class='white'
            onClick={() => onChange(key as BidIntentStatus)}
            leftIcon={value.icon('var(--gray-700)')}
          >
            {bidIntentText[key as BidIntentStatus]}
          </BtButton>
      ))) : (
        <OptionsMenu
          selectedItem={bidIntentText[status]}
          options={Object.keys(bidIntentOptions).map((key) => ({label: bidIntentText[key as BidIntentStatus], action: () => onChange(key as BidIntentStatus)}))}>
          <BtButton
            rightIcon={<ArrowIcon color={bidIntentOptions[status].color} />}
            class={bidIntentOptions[status].className}
          >
            {bidIntentOptions[status].icon()}
            {bidIntentText[status]}
          </BtButton>
        </OptionsMenu>
      )}
    </div>
  );
}

export default BidIntentControls;
